/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_Contact_PersonInputs */

const en_admin_registration_contact_person = /** @type {(inputs: Admin_Registration_Contact_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Person`)
};

const de_admin_registration_contact_person = /** @type {(inputs: Admin_Registration_Contact_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktperson`)
};

/**
* | output |
* | --- |
* | "Contact Person" |
*
* @param {Admin_Registration_Contact_PersonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_contact_person = /** @type {((inputs?: Admin_Registration_Contact_PersonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_Contact_PersonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_contact_person(inputs)
	return en_admin_registration_contact_person(inputs)
});